<button
  class="wo-show-more-input-button"
  tuiButton
  appearance="flat"
  (click)="toggle.emit()"
  [showLoader]="loading ?? false"
>
  {{ value ? 'Show less' : 'Show more' }}
</button>
